import { render, staticRenderFns } from "./CardCore.vue?vue&type=template&id=be345f6a&scoped=true&"
import script from "./CardCore.vue?vue&type=script&lang=js&"
export * from "./CardCore.vue?vue&type=script&lang=js&"
import style0 from "./CardCore.vue?vue&type=style&index=0&id=be345f6a&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be345f6a",
  null
  
)

export default component.exports